var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInnovate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-5",
    cx: 250.15,
    cy: 375.49,
    rx: 230.53,
    ry: 105.2,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.18,92,178,96.77a10,10,0,0,0,.07-1.08V93.31c0-4.24-3-6-6.64-3.84a12.88,12.88,0,0,0-4,3.81c-.6-5.33-4.78-7.31-9.85-4.38-5.49,3.17-9.94,10.87-9.94,17.21v3.56a9.46,9.46,0,0,0,.84,4.12l-6.82,3.94a8.16,8.16,0,0,0-3.68,6.38c0,2.35,1.65,3.3,3.68,2.13l44.52-25.7a8.16,8.16,0,0,0,3.68-6.38C189.86,91.81,188.21,90.86,186.18,92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.45,93,79.57,89V77.76c0-8.94,7.13-19.31,14.86-23.78h0c7.74-4.47,14-.85,14,8.09v1.64A19.91,19.91,0,0,1,115,57.2h0C120.52,54,125,56.59,125,63v.75l7.14-4.12c3.67-2.12,6.64-.41,6.64,3.83A14.68,14.68,0,0,1,132.17,75L74.45,108.31c-3.67,2.11-6.64.4-6.64-3.84A14.68,14.68,0,0,1,74.45,93Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-5",
    d: "M467.65,386.41c0-.26,0-.51-.06-.77,0-.07,0-.13,0-.2s-.06-.37-.1-.55l-.06-.2a5.08,5.08,0,0,0-.15-.52c0-.06-.05-.11-.07-.17s-.14-.36-.22-.54l-.06-.12c-.1-.18-.19-.37-.3-.55l0-.07c-.12-.19-.24-.38-.38-.56l0,0c-.14-.19-.3-.37-.46-.55h0a7.55,7.55,0,0,0-2.2-1.63h0q-.36-.17-.72-.3l-.06,0c-.22-.08-.45-.14-.68-.2l-.13,0c-.21-.05-.43-.08-.64-.11l-.17,0a7.26,7.26,0,0,0-4.37.86c0-.09-.07-.19-.1-.29s-.07-.18-.11-.27c-.11-.3-.23-.6-.37-.89l-.1-.2c-.15-.31-.32-.61-.49-.91a.83.83,0,0,1-.08-.12c-.2-.32-.41-.62-.63-.92l-.05-.06a9.5,9.5,0,0,0-.76-.9v0a12.38,12.38,0,0,0-3.66-2.7h0a11.41,11.41,0,0,0-1.19-.49l-.1,0a10.33,10.33,0,0,0-1.12-.33l-.21-.05c-.35-.08-.71-.14-1.07-.19l-.28,0a11.94,11.94,0,0,0-1.35-.08,12.26,12.26,0,0,0-12,9.69,17.05,17.05,0,0,0-3.68-2.41h0c-.51-.24-1-.46-1.56-.65l-.27-.1c-.34-.12-.68-.22-1-.32l-.82-.21-.56-.11c-.42-.08-.85-.14-1.28-.19l-.31,0c-.5,0-1-.07-1.51-.07a16.87,16.87,0,0,0-16.55,13.64c-.22-.33-.46-.65-.69-1l-.19-.24c-.38-.49-.78-1-1.2-1.43l-.07-.07a20,20,0,0,0-1.48-1.43h0a20.89,20.89,0,0,0-6.68-4l-.33-.12c-.42-.14-.84-.27-1.27-.39l-1-.26-.69-.14c-.52-.1-1-.18-1.58-.24l-.39,0c-.61-.06-1.24-.09-1.87-.09a20.94,20.94,0,0,0-20.9,19.8l-.05,0,0,0a19.12,19.12,0,0,0-5.7-4.2h0a17.4,17.4,0,0,0-1.77-.75l-.3-.11q-.57-.19-1.17-.36l-.92-.23-.64-.13c-.47-.09-.95-.16-1.44-.22l-.35,0c-.57-.05-1.13-.08-1.71-.08a19.14,19.14,0,0,0-19.13,18.61c0,.18,0,.35,0,.53s0,.35,0,.53.05.29.07.43l-.15,0-.13,0c-.21-.05-.43-.09-.64-.12l-.17,0a7.37,7.37,0,0,0-.82-.05,7.26,7.26,0,0,0-3.41.84,18.2,18.2,0,0,0-18.2-17.69c-.54,0-1.08,0-1.61.08l-.35,0c-.46.05-.91.12-1.37.2l-.6.13c-.3.06-.59.14-.88.22s-.75.22-1.11.34l-.28.1c-.58.21-1.14.45-1.69.71h0l-.8.4c0-.15,0-.3,0-.46a21,21,0,0,0-21-20.39c-.63,0-1.25,0-1.86.1l-.39,0c-.54.06-1.06.14-1.58.24l-.7.14c-.34.08-.68.16-1,.26l-.14,0a17.78,17.78,0,0,0-17.65-15.56c-.53,0-1.06,0-1.58.07l-.33,0c-.46.05-.9.12-1.34.2l-.59.12-.87.22c-.36.1-.72.22-1.08.34l-.28.1a15.78,15.78,0,0,0-1.64.69h0a18.14,18.14,0,0,0-4,2.67h0a16.54,16.54,0,0,0-1.27,1.24l0,0c-.39.41-.75.85-1.1,1.3l-.07.09c-.32.43-.62.88-.91,1.34l-.11.18q-.39.65-.72,1.32c-.05.09-.1.19-.14.28-.17.36-.32.72-.47,1.09h0a14.76,14.76,0,0,0-1.5.08l-.32,0c-.42,0-.84.1-1.25.18a12.21,12.21,0,0,0-13.54-10.83l-.27,0c-.37,0-.72.11-1.07.19l-.21.05a10.51,10.51,0,0,0-1.13.33l-.09,0c-.41.15-.81.32-1.19.5h0a12.46,12.46,0,0,0-3.65,2.7l0,0a9.41,9.41,0,0,0-.75.9l0,.06a10,10,0,0,0-.63.92l-.08.12c-.18.3-.34.6-.49.91a1.86,1.86,0,0,0-.1.2c-.14.29-.26.59-.38.89l-.1.27c0,.1-.07.2-.1.29a7.26,7.26,0,0,0-4.37-.86l-.17,0a4.5,4.5,0,0,0-.64.11l-.13,0c-.23.06-.46.12-.68.2l-.06,0a7.76,7.76,0,0,0-.72.3h0a7.57,7.57,0,0,0-1.68,1.12h0c-.18.16-.36.33-.53.51h0c-.16.18-.31.36-.46.55l0,0c-.13.18-.25.37-.37.56l-.05.07c-.11.18-.21.37-.3.55l-.06.12c-.08.18-.16.36-.23.54l-.06.16c-.06.18-.11.36-.16.53a1.94,1.94,0,0,0-.05.2,5.35,5.35,0,0,0-.11.55l0,.2a6.48,6.48,0,0,0-.06.77,1.48,1.48,0,0,0,0,.21,1.34,1.34,0,0,0,0,.2,3.77,3.77,0,0,0,2.16,2.82,11.32,11.32,0,0,0,6.79,1.16h0a10.66,10.66,0,0,0,1.13-.19l.37-.1c.29-.07.56-.16.83-.25l.35-.13a7,7,0,0,0,1-.49c.18-.1.34-.2.49-.3l.05,0c.13-.1.26-.19.37-.29h0a2.28,2.28,0,0,0,.22-.22l.16.11a18.05,18.05,0,0,0,9.16,2.06c-.13.23-.24.48-.36.72-.05.09-.1.18-.14.27a13.26,13.26,0,0,0-.51,1.23l-.15.37c-.14.4-.25.8-.36,1.21,0,.15-.09.3-.13.45-.09.41-.17.83-.23,1.25,0,.16-.06.3-.08.46a14.41,14.41,0,0,0-.14,1.75,5.53,5.53,0,0,0,0,.94c.19,2.34,1.84,4.63,4.93,6.43,4.19,2.41,10,3.29,15.42,2.64h0c.72-.09,1.43-.21,2.13-.35l.28-.06c.71-.15,1.41-.32,2.08-.53h0c.62-.19,1.22-.42,1.8-.66l.43-.18a18.15,18.15,0,0,0,1.71-.85c.39-.23.76-.46,1.1-.7l.16-.13c.29-.2.56-.41.81-.62l0,0a10.49,10.49,0,0,0,1.46-1.55h0a6.59,6.59,0,0,0,1.35-3.39,3.7,3.7,0,0,0,0-.47c0-.05,0-.1,0-.15a28.36,28.36,0,0,0,3.33-.22h0l.27,0c-.14.34-.28.69-.4,1l-.16.48c-.16.52-.31,1-.44,1.57,0,.11,0,.22-.07.34-.12.58-.23,1.16-.31,1.76,0,.06,0,.12,0,.18-.08.65-.13,1.31-.15,2a5.62,5.62,0,0,0,0,.58,5.82,5.82,0,0,0,0,.59c.24,2.9,2.28,5.75,6.12,8,5.2,3,12.44,4.09,19.14,3.28h.12c.75-.1,1.5-.22,2.23-.36l.76-.15.86-.2.95-.25.64-.19c.51-.15,1-.32,1.48-.5l.52-.21c.22-.09.45-.17.67-.27,0,0,0,.1-.05.15-.15.43-.27.86-.39,1.3,0,.17-.1.32-.14.49-.1.44-.18.89-.25,1.34l-.09.5q-.12.93-.15,1.89c0,.17,0,.33,0,.5s0,.34,0,.51c.21,2.52,2,5,5.31,6.93,5.12,3,12.52,3.76,18.92,2.47l.3-.06c.76-.17,1.51-.35,2.24-.58h0c.67-.21,1.32-.45,1.95-.71l.46-.2a19.68,19.68,0,0,0,1.84-.91c.42-.25.82-.5,1.19-.76l.15-.12,0,0a3,3,0,0,0,.55,1.22h0a4,4,0,0,0,.64.67l0,0,.36.27a.18.18,0,0,0,.07.05,5.66,5.66,0,0,0,.48.31,7.09,7.09,0,0,0,1,.49l.34.13c.27.09.55.18.83.25l.37.09a10.43,10.43,0,0,0,1.14.2h0a11.28,11.28,0,0,0,6.8-1.15,3.81,3.81,0,0,0,2.16-2.82,1.41,1.41,0,0,0,0-.21,1.34,1.34,0,0,0,0-.2s0-.08,0-.12l0,0a14.55,14.55,0,0,0,1.3.68l.41.19q.49.23,1,.42l.47.19c.44.16.89.32,1.35.46l.59.17.86.23.79.18.69.14c.65.12,1.31.23,2,.32l.18,0h0c6.11.74,12.73-.26,17.48-3,3.5-2,5.36-4.63,5.58-7.28,0-.18,0-.35,0-.53s0-.35,0-.53a18.84,18.84,0,0,0-.16-2c0-.17-.06-.34-.09-.51-.06-.39-.12-.78-.2-1.16a1.27,1.27,0,0,0,.12.1c.42.29.88.58,1.37.87s.93.5,1.41.74l.46.21,1.08.46.51.2c.49.18,1,.35,1.48.5l.66.19.93.25.87.2.75.15c7.3,1.41,15.68.45,21.5-2.9,3.83-2.23,5.88-5.08,6.12-8,0-.2,0-.38,0-.58s0-.39,0-.59c0-.56-.06-1.11-.12-1.66l0,0,.11.09c.35.24.71.47,1.1.7a18.15,18.15,0,0,0,1.71.85l.43.18a18.58,18.58,0,0,0,1.81.66h0c.67.21,1.37.39,2.08.54l.28.06c5.93,1.2,12.8.44,17.55-2.3,3.09-1.79,4.74-4.09,4.93-6.43,0-.16,0-.31,0-.47s0-.31,0-.47c0-.59-.07-1.17-.14-1.75,0-.15-.06-.3-.08-.46-.07-.42-.14-.84-.24-1.25l-.09-.34.85.29h0c.49.15,1,.27,1.51.38l.21,0c4.31.88,9.3.33,12.74-1.66l.17-.1a4.15,4.15,0,0,0,.63.52l0,0a5.6,5.6,0,0,0,.48.3,7.09,7.09,0,0,0,1,.49l.34.13c.27.09.55.18.83.25l.37.1a10.84,10.84,0,0,0,1.14.19h0a11.35,11.35,0,0,0,6.8-1.16,3.8,3.8,0,0,0,2.16-2.82,1.34,1.34,0,0,0,0-.2A1.48,1.48,0,0,0,467.65,386.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-5",
    cx: 151.44,
    cy: 409.19,
    rx: 50.96,
    ry: 29.42,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.46,345.5l-9.6-5.08a214.28,214.28,0,0,1,.41-26.3c1.61-16.35,13.76-35.32,26.35-30.7s-5.77,21.26-9.86,35.12S453.46,345.5,453.46,345.5Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.46,345.5l-9.6-5.08a214.28,214.28,0,0,1,.41-26.3c1.61-16.35,13.76-35.32,26.35-30.7s-5.77,21.26-9.86,35.12S453.46,345.5,453.46,345.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.77,343.8h0a.42.42,0,0,0,.41-.44c-1.23-36.31,16.85-54.58,17-54.76a.42.42,0,0,0-.6-.6c-.18.18-18.52,18.71-17.28,55.39A.43.43,0,0,0,448.77,343.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.39,348.4l-5-2.88a55.89,55.89,0,0,1,3.09-24.23c4.63-12.55,16.58-19.39,22.08-17.52,6.71,2.28,6.75,8.71,4.31,12.94C480,321.69,462,334.29,458.39,348.4Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.39,348.4l-5-2.88a55.89,55.89,0,0,1,3.09-24.23c4.63-12.55,16.58-19.39,22.08-17.52,6.71,2.28,6.75,8.71,4.31,12.94C480,321.69,462,334.29,458.39,348.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.75,347.3h0a.42.42,0,0,0,.42-.42c-.1-23,21.46-38.48,21.68-38.63a.43.43,0,0,0-.5-.7c-.22.16-22.13,15.93-22,39.33A.42.42,0,0,0,455.75,347.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.27,345.13l6.24-3.56s3-16.49.75-30.67C56.12,291,42.55,284.1,37.62,286.08s-6.09,7.88,2.81,19.4C45.68,312.27,52.44,326.64,52.27,345.13Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.27,345.13l6.24-3.56s3-16.49.75-30.67C56.12,291,42.55,284.1,37.62,286.08s-6.09,7.88,2.81,19.4C45.68,312.27,52.44,326.64,52.27,345.13Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M54.53,337.22h-.06a.45.45,0,0,1-.38-.5c2.58-18.66-4.93-39.1-13.36-47.34a.44.44,0,0,1,0-.63.45.45,0,0,1,.63,0c8.58,8.39,16.23,29.17,13.61,48.1A.44.44,0,0,1,54.53,337.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,355.13c-1,.57-3-.67-3.8-1.19A9.51,9.51,0,0,1,28,350.35a8.87,8.87,0,0,1-.78-5.3,20.88,20.88,0,0,1,.67-2.81c.26-.91.52-1.83.79-2.74a7,7,0,0,0,.4-2.75c-.24-1.87-1.9-3.18-3.41-4.31-1.67-1.25-3.4-2.9-3.4-5.15a7.9,7.9,0,0,1,2-4.71c1.07-1.36,2.35-2.57,3.32-4a5.54,5.54,0,0,0,1.14-3.49,5.91,5.91,0,0,0-.77-2.19,31,31,0,0,1-2.39-4.38,4.41,4.41,0,0,1,.76-4.66,5.18,5.18,0,0,1,3.87-1,8.69,8.69,0,0,1,3.6,1.27c3.58,2,5.62,6.21,9.41,7.74A37,37,0,0,0,47.82,313a5.71,5.71,0,0,1,3.78,2.6c1.39,2.78-1.19,6.2-.21,9.15.86,2.61,3.4,3.61,4.82,6a5.54,5.54,0,0,1,.67,3.42,16.5,16.5,0,0,1-1.44,5.78,42,42,0,0,1-3.17,5.2C52.21,345.19,35.11,355.05,35,355.13Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.09,349.74h0a.45.45,0,0,1-.43-.47c.74-17.66-7.58-37.16-13.64-42.82a.46.46,0,0,1,0-.63.44.44,0,0,1,.63,0c6.18,5.78,14.67,25.6,13.92,43.51A.45.45,0,0,1,45.09,349.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.44,328.87l-.13,0a60.66,60.66,0,0,0-12.82-2.07.44.44,0,0,1-.42-.46.42.42,0,0,1,.46-.42,60.22,60.22,0,0,1,13,2.1.44.44,0,0,1-.13.87Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.24,221.26c0-17,12-37.76,26.72-46.28,7.39-4.27,14.08-4.67,18.91-1.86L80.19,175a31.85,31.85,0,0,1,4.49,15.38c0,17-12,37.76-26.72,46.28a31.63,31.63,0,0,1-15.56,3.8l-3.34-1.93C34.23,235.77,31.24,229.78,31.24,221.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.26,230.38l-33.7-19.46a43.7,43.7,0,0,0-1.32,10.34c0,8.52,3,14.51,7.82,17.3l3.34,1.93A31.63,31.63,0,0,0,58,236.69,44.21,44.21,0,0,0,66.26,230.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.3,
    cy: 207.76,
    rx: 37.79,
    ry: 21.82,
    transform: "translate(-149.28 156.97) rotate(-60)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.55,220.66c0-14.06,9.87-31.16,22-38.19,6.1-3.52,11.62-3.84,15.61-1.53l11.38,6.57a26.26,26.26,0,0,1,3.7,12.68c0,14.06-9.87,31.16-22,38.19a26.07,26.07,0,0,1-12.83,3.13L46,234.93C42,232.63,39.55,227.69,39.55,220.66Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9,199.11C42,206,39.55,213.69,39.55,220.66s2.46,12,6.45,14.27l11.4,6.58a26.07,26.07,0,0,0,12.83-3.13c6-3.49,11.51-9.45,15.49-16.28Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.28,200.19c0,7.09-2.51,14.95-6.57,21.91l-39.81-23c4-7,9.55-13.09,15.69-16.64s11.62-3.84,15.61-1.53l11.38,6.57A26.26,26.26,0,0,1,92.28,200.19Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,215.22a49.13,49.13,0,0,1,5.9-16.11l39.81,23a48.7,48.7,0,0,1-11,13.16Z",
    style: {
      fill: "#9615DB",
      opacity: 0.76
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.94,227.24c0-14.06,9.87-31.15,22-38.18S95,187.72,95,201.78,85.17,232.94,73,240,50.94,241.3,50.94,227.24Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,231.63a.79.79,0,0,1-.11-.5V219.66a1.15,1.15,0,0,1,.69-1l.47-.27c.46-.26.69-.2.69.19v9.81l1.76-1c.13-.07.22,0,.27.07a1.5,1.5,0,0,1,.09.64v.57a2.32,2.32,0,0,1-.09.73.58.58,0,0,1-.27.38l-3.17,1.83C55.19,231.7,55.08,231.7,55,231.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.37,228.92a2.5,2.5,0,0,1,0-.35l1.82-12.63A1.31,1.31,0,0,1,62,215l.77-.44c.44-.26.68-.23.74.08l1.82,10.53c0,.16,0,.27,0,.32a.84.84,0,0,1-.51.69l-.63.36c-.37.22-.58.21-.62,0l-.31-2-1.8,1-.32,2.4a.93.93,0,0,1-.55.7l-.62.36C59.56,229.21,59.37,229.19,59.37,228.92ZM63,222.38l-.53-3.55c-.06-.41-.1-.84-.14-1.3l-.06,0q-.06.76-.15,1.47l-.52,4.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,224a3,3,0,0,1-.76-2.43v-8.46a1.14,1.14,0,0,1,.69-1l.47-.28c.46-.26.69-.2.69.19v8.29a1.58,1.58,0,0,0,.27,1.05c.18.21.43.22.73,0a1.79,1.79,0,0,0,.73-.89,3.28,3.28,0,0,0,.28-1.36V210.9a1.15,1.15,0,0,1,.69-1l.46-.26c.45-.27.68-.21.68.18v8.47a7.06,7.06,0,0,1-.75,3.29,5.37,5.37,0,0,1-2.09,2.23C68.18,224.34,67.49,224.41,67,224Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.43,220.62V209a1.13,1.13,0,0,1,.68-1l.31-.18a.68.68,0,0,1,.38-.12c.09,0,.17.11.23.28l2.13,4.7a11.69,11.69,0,0,1,.41,1.19l0-.06q-.09-.9-.09-1.38v-5.81a1.14,1.14,0,0,1,.68-1l.29-.17c.46-.26.68-.2.68.19V217.3a1.13,1.13,0,0,1-.68,1l-.23.13a.69.69,0,0,1-.39.13c-.1,0-.18-.1-.25-.27l-2.25-4.89a5.38,5.38,0,0,1-.32-1l-.06.09a11.3,11.3,0,0,1,.09,1.19v6a1.16,1.16,0,0,1-.68,1l-.29.16C73.65,221.07,73.43,221,73.43,220.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.27,215.21c-.5-.76-.75-2.28-.75-4.55a15,15,0,0,1,.79-5.33,5.61,5.61,0,0,1,2.43-3,3.07,3.07,0,0,1,1-.39c.24,0,.37.16.37.57a5.83,5.83,0,0,1-.16,1.33c-.11.42-.24.64-.4.65a1.89,1.89,0,0,0-.76.25,2.65,2.65,0,0,0-1.06,1.61,12.26,12.26,0,0,0-.35,3.25,8.09,8.09,0,0,0,.35,2.85.69.69,0,0,0,1.12.36,1.94,1.94,0,0,0,.38-.26c.1-.09.24-.22.4-.39l.11-.08c.16-.09.28,0,.35.25a4.08,4.08,0,0,1,.12,1.13,1.61,1.61,0,0,1-.07.51,1.38,1.38,0,0,1-.27.46,5.37,5.37,0,0,1-.53.5,4.43,4.43,0,0,1-.69.47C82.58,216,81.78,216,81.27,215.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.48,213.08V201.43a1.14,1.14,0,0,1,.69-1l.5-.29c.45-.26.67-.19.67.2v4.49l2-1.16v-4.5a1.14,1.14,0,0,1,.69-1l.48-.28c.46-.26.69-.2.69.19v11.65a1.14,1.14,0,0,1-.69,1l-.48.28c-.46.26-.69.2-.69-.19v-4.75l-2,1.17V212a1.12,1.12,0,0,1-.67,1l-.5.29C86.71,213.53,86.48,213.47,86.48,213.08Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.71,388c0,13.43-26.57,24.32-59.34,24.32S272,401.44,272,388s26.57-24.33,59.34-24.33S390.71,374.57,390.71,388Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.71,388c0,13.43-26.57,24.32-59.34,24.32S272,401.44,272,388s26.57-24.33,59.34-24.33S390.71,374.57,390.71,388Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.37,
    cy: 388.01,
    rx: 64.2,
    ry: 26.32,
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.93,366.44a26.37,26.37,0,0,1,52.72,0c0,.25,0,.48,0,.73s0,.49,0,.74c-.3,3.65-2.87,7.23-7.72,10-10.28,5.95-27,5.95-37.31,0-4.82-2.8-7.39-6.38-7.69-10,0-.25,0-.48,0-.74S270.91,366.69,270.93,366.44Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.93,366.44a26.37,26.37,0,0,1,52.72,0c0,.25,0,.48,0,.73s0,.49,0,.74c-.3,3.65-2.87,7.23-7.72,10-10.28,5.95-27,5.95-37.31,0-4.82-2.8-7.39-6.38-7.69-10,0-.25,0-.48,0-.74S270.91,366.69,270.93,366.44Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.85,343.43h0a26.32,26.32,0,0,1,37.8,23c0,.25,0,.48,0,.73s0,.49,0,.74c-.3,3.65-2.87,7.23-7.72,10a35.24,35.24,0,0,1-13.23,4.13c6.84-1.18,11.27-8.82,9.17-17.25C309.43,355,299.54,340.9,285.85,343.43Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.93,367.91c0-.25,0-.48,0-.74s0-.48,0-.73a26.23,26.23,0,0,1,8.95-19.05c-2.86,2.94-9.23,14-2.31,22.5,4.55,5.57,26.17,13.51,44,3.3a18.31,18.31,0,0,1-5.6,4.75c-10.28,5.95-27,5.95-37.31,0C273.8,375.14,271.23,371.56,270.93,367.91Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.56,346.74c-1.18,2.69,1.08,6.28,5.06,8s8.16,1,9.34-1.71-1.09-6.28-5.06-8S298.74,344.05,297.56,346.74Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.83,357.68c-.61,1.4.28,3.14,2,3.9s3.61.23,4.22-1.17-.27-3.15-2-3.9S313.45,356.28,312.83,357.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.15,366a22.39,22.39,0,0,0-44.77,0c0,.22,0,.41,0,.63s0,.41,0,.62c.25,3.1,2.44,6.14,6.55,8.52,8.74,5.05,22.93,5.05,31.69,0,4.09-2.38,6.27-5.42,6.53-8.52,0-.21,0-.41,0-.62S381.17,366.25,381.15,366Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.15,366a22.39,22.39,0,0,0-44.77,0c0,.22,0,.41,0,.63s0,.41,0,.62c.25,3.1,2.44,6.14,6.55,8.52,8.74,5.05,22.93,5.05,31.69,0,4.09-2.38,6.27-5.42,6.53-8.52,0-.21,0-.41,0-.62S381.17,366.25,381.15,366Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.48,346.49h0A22.35,22.35,0,0,0,336.38,366c0,.22,0,.41,0,.63s0,.41,0,.62c.25,3.1,2.44,6.14,6.55,8.52a29.78,29.78,0,0,0,11.24,3.51c-5.81-1-9.57-7.49-7.79-14.65C348.46,356.35,356.86,344.34,368.48,346.49Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.15,367.28c0-.21,0-.41,0-.62s0-.41,0-.63a22.29,22.29,0,0,0-7.6-16.18c2.43,2.5,7.84,11.93,2,19.12-3.87,4.72-22.22,11.47-37.33,2.8a15.5,15.5,0,0,0,4.75,4c8.74,5.05,22.93,5.05,31.69,0C378.71,373.42,380.89,370.38,381.15,367.28Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.54,349.3c1,2.28-.93,5.34-4.3,6.82s-6.93.84-7.94-1.45.93-5.33,4.31-6.82S357.53,347,358.54,349.3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.57,358.59a2.94,2.94,0,1,1-3.59-1A2.66,2.66,0,0,1,345.57,358.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,368.61a14.81,14.81,0,0,0-29.6,0,2.82,2.82,0,0,0,0,.41,2.88,2.88,0,0,0,0,.42c.17,2.05,1.61,4.06,4.33,5.63,5.78,3.34,15.16,3.34,20.95,0,2.71-1.57,4.15-3.58,4.32-5.63,0-.14,0-.27,0-.42S403,368.75,403,368.61Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,368.61a14.81,14.81,0,0,0-29.6,0,2.82,2.82,0,0,0,0,.41,2.88,2.88,0,0,0,0,.42c.17,2.05,1.61,4.06,4.33,5.63,5.78,3.34,15.16,3.34,20.95,0,2.71-1.57,4.15-3.58,4.32-5.63,0-.14,0-.27,0-.42S403,368.75,403,368.61Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.63,355.69h0a14.78,14.78,0,0,0-21.22,12.92,2.82,2.82,0,0,0,0,.41,2.88,2.88,0,0,0,0,.42c.17,2.05,1.61,4.06,4.33,5.63a19.76,19.76,0,0,0,7.43,2.32c-3.84-.66-6.33-4.95-5.15-9.69C381.39,362.21,387,354.27,394.63,355.69Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,369.44c0-.14,0-.27,0-.42s0-.27,0-.41a14.76,14.76,0,0,0-5-10.7c1.6,1.66,5.18,7.89,1.29,12.64-2.55,3.13-14.69,7.59-24.68,1.86a10.32,10.32,0,0,0,3.14,2.66c5.78,3.34,15.16,3.34,20.95,0C401.4,373.5,402.84,371.49,403,369.44Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.06,357.55c.66,1.51-.61,3.53-2.85,4.51s-4.58.55-5.24-1,.61-3.53,2.84-4.51S387.4,356,388.06,357.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.48,363.69a1.94,1.94,0,0,1-3.49,1.53,1.94,1.94,0,0,1,3.49-1.53Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.55,375.05a20.12,20.12,0,0,0-40.23,0c0,.2,0,.37,0,.56s0,.37,0,.56c.23,2.79,2.19,5.52,5.89,7.66,7.85,4.54,20.61,4.54,28.47,0,3.68-2.14,5.65-4.87,5.87-7.66a5.15,5.15,0,0,0,0-.56A5.33,5.33,0,0,0,434.55,375.05Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.55,375.05a20.12,20.12,0,0,0-40.23,0c0,.2,0,.37,0,.56s0,.37,0,.56c.23,2.79,2.19,5.52,5.89,7.66,7.85,4.54,20.61,4.54,28.47,0,3.68-2.14,5.65-4.87,5.87-7.66a5.15,5.15,0,0,0,0-.56A5.33,5.33,0,0,0,434.55,375.05Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.17,357.49h0a20.1,20.1,0,0,0-28.85,17.56c0,.2,0,.37,0,.56s0,.37,0,.56c.23,2.79,2.19,5.52,5.89,7.66a26.85,26.85,0,0,0,10.1,3.15c-5.22-.9-8.6-6.73-7-13.16C405.18,366.35,412.72,355.56,423.17,357.49Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.55,376.17a5.15,5.15,0,0,0,0-.56,5.33,5.33,0,0,0,0-.56,20,20,0,0,0-6.83-14.54c2.19,2.25,7,10.72,1.77,17.18-3.48,4.25-20,10.31-33.55,2.52a14,14,0,0,0,4.27,3.62c7.85,4.54,20.61,4.54,28.47,0C432.36,381.69,434.33,379,434.55,376.17Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.23,360c.91,2.05-.83,4.79-3.86,6.12s-6.23.76-7.13-1.3.83-4.79,3.87-6.12S413.33,358,414.23,360Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.58,368.37a2.64,2.64,0,1,1-3.22-.9A2.38,2.38,0,0,1,402.58,368.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.45,298.44A24,24,0,0,1,347,316.76a15.66,15.66,0,0,0-5.69,11.92v57.61c0,1.46-1,2.93-2.9,4a12.26,12.26,0,0,1-3.63,1.33,16.89,16.89,0,0,1-6.72,0,12.66,12.66,0,0,1-3.62-1.33c-1.93-1.11-2.89-2.58-2.89-4V328.57a15.52,15.52,0,0,0-5.67-11.79,23.91,23.91,0,0,1-8.52-18.53,24.07,24.07,0,0,1,48.13.19Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.45,298.44A24,24,0,0,1,347,316.76a15.66,15.66,0,0,0-5.69,11.92v57.61c0,1.46-1,2.93-2.9,4a12.26,12.26,0,0,1-3.63,1.33,16.89,16.89,0,0,1-6.72,0,12.66,12.66,0,0,1-3.62-1.33c-1.93-1.11-2.89-2.58-2.89-4V328.57a15.52,15.52,0,0,0-5.67-11.79,23.91,23.91,0,0,1-8.52-18.53,24.07,24.07,0,0,1,48.13.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.81,298.44a13.38,13.38,0,0,1-5.66,10.93,10.91,10.91,0,0,0-4.41,8.93v69.42a3.4,3.4,0,0,1-3.33,3.44h-.06a3.4,3.4,0,0,1-3.33-3.44V318.13a10.71,10.71,0,0,0-4.41-8.76A13.42,13.42,0,0,1,318,298.06a13.57,13.57,0,0,1,12.89-13A13.43,13.43,0,0,1,344.81,298.44Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.81,298.44a13.38,13.38,0,0,1-5.66,10.93,10.91,10.91,0,0,0-4.41,8.93v69.42a3.4,3.4,0,0,1-3.33,3.44h-.06a3.4,3.4,0,0,1-3.33-3.44V318.13a10.71,10.71,0,0,0-4.41-8.76A13.42,13.42,0,0,1,318,298.06a13.57,13.57,0,0,1,12.89-13A13.43,13.43,0,0,1,344.81,298.44Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.58,
    cy: 309.94,
    r: 5.09,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.59,294.84a3.84,3.84,0,1,1,3.83,3.84A3.84,3.84,0,0,1,337.59,294.84Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.27,288.73a1.9,1.9,0,1,1,1.9,1.9A1.9,1.9,0,0,1,330.27,288.73Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1,291a5.15,5.15,0,1,1,5.15,5.15A5.14,5.14,0,0,1,315.1,291Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.24,300.32a2.42,2.42,0,1,0,2.41-2.41A2.41,2.41,0,0,0,314.24,300.32Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.5,309.56a4.7,4.7,0,1,1,4.69,4.69A4.69,4.69,0,0,1,314.5,309.56Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.16,316.41a3.24,3.24,0,1,1,3.23,3.23A3.23,3.23,0,0,1,326.16,316.41Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.65,294.84a1.65,1.65,0,1,1,1.65,1.65A1.64,1.64,0,0,1,309.65,294.84Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5,288a2.17,2.17,0,1,1,2.17,2.17A2.17,2.17,0,0,1,345.5,288Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.66,298.68a2.18,2.18,0,1,1,2.18,2.18A2.18,2.18,0,0,1,347.66,298.68Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.21,300.86a2.19,2.19,0,1,1,2.18,2.18A2.18,2.18,0,0,1,327.21,300.86Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.27,378.54a12.26,12.26,0,0,0-24.52,0c0,.12,0,.22,0,.34s0,.22,0,.34c.14,1.7,1.34,3.37,3.59,4.67,4.79,2.76,12.56,2.76,17.35,0,2.25-1.3,3.44-3,3.58-4.67,0-.12,0-.22,0-.34S457.28,378.66,457.27,378.54Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.27,378.54a12.26,12.26,0,0,0-24.52,0c0,.12,0,.22,0,.34s0,.22,0,.34c.14,1.7,1.34,3.37,3.59,4.67,4.79,2.76,12.56,2.76,17.35,0,2.25-1.3,3.44-3,3.58-4.67,0-.12,0-.22,0-.34S457.28,378.66,457.27,378.54Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.33,367.83h0a12.25,12.25,0,0,0-17.58,10.71c0,.12,0,.22,0,.34s0,.22,0,.34c.14,1.7,1.34,3.37,3.59,4.67a16.32,16.32,0,0,0,6.15,1.92c-3.18-.55-5.24-4.1-4.26-8C439.37,373.23,444,366.66,450.33,367.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.27,379.22c0-.12,0-.22,0-.34s0-.22,0-.34a12.18,12.18,0,0,0-4.16-8.86c1.33,1.37,4.3,6.53,1.07,10.46-2.11,2.59-12.17,6.29-20.44,1.54a8.55,8.55,0,0,0,2.6,2.21c4.79,2.76,12.56,2.76,17.35,0C455.94,382.59,457.13,380.92,457.27,379.22Z",
    style: {
      fill: "#9615DB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.89,369.37c.55,1.25-.51,2.93-2.36,3.74s-3.79.46-4.34-.79.5-2.93,2.35-3.74S444.34,368.12,444.89,369.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.78,374.46a1.61,1.61,0,1,1-2-.54A1.46,1.46,0,0,1,437.78,374.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.91,388.63a16.89,16.89,0,0,0-33.77,0c0,.16,0,.31,0,.47s0,.31,0,.47c.19,2.34,1.84,4.64,4.94,6.43,6.59,3.81,17.3,3.81,23.9,0,3.09-1.79,4.74-4.09,4.93-6.43,0-.16,0-.31,0-.47S438.92,388.79,438.91,388.63Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.91,388.63a16.89,16.89,0,0,0-33.77,0c0,.16,0,.31,0,.47s0,.31,0,.47c.19,2.34,1.84,4.64,4.94,6.43,6.59,3.81,17.3,3.81,23.9,0,3.09-1.79,4.74-4.09,4.93-6.43,0-.16,0-.31,0-.47S438.92,388.79,438.91,388.63Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.35,373.89h0a16.88,16.88,0,0,0-24.21,14.74c0,.16,0,.31,0,.47s0,.31,0,.47c.19,2.34,1.84,4.64,4.94,6.43a22.45,22.45,0,0,0,8.48,2.64c-4.38-.75-7.22-5.64-5.87-11.05C414.25,381.33,420.59,372.27,429.35,373.89Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.91,389.57c0-.16,0-.31,0-.47s0-.31,0-.47a16.82,16.82,0,0,0-5.74-12.2c1.84,1.89,5.92,9,1.49,14.41-2.92,3.57-16.77,8.66-28.16,2.12a12,12,0,0,0,3.58,3c6.59,3.81,17.3,3.81,23.9,0C437.07,394.21,438.72,391.91,438.91,389.57Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.85,376c.76,1.73-.69,4-3.24,5.15s-5.23.63-6-1.09.69-4,3.24-5.15S421.1,374.29,421.85,376Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.07,383a2.22,2.22,0,1,1-2.7-.75A2,2,0,0,1,412.07,383Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,396.85a21,21,0,0,0-41.91,0,5.72,5.72,0,0,0,0,.59,5.62,5.62,0,0,0,0,.58c.24,2.9,2.28,5.75,6.13,8,8.18,4.72,21.47,4.72,29.66,0,3.83-2.23,5.88-5.08,6.12-8,0-.2,0-.38,0-.58S409,397.05,409,396.85Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,396.85a21,21,0,0,0-41.91,0,5.72,5.72,0,0,0,0,.59,5.62,5.62,0,0,0,0,.58c.24,2.9,2.28,5.75,6.13,8,8.18,4.72,21.47,4.72,29.66,0,3.83-2.23,5.88-5.08,6.12-8,0-.2,0-.38,0-.58S409,397.05,409,396.85Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.1,378.56h0a20.94,20.94,0,0,0-30.05,18.29,5.72,5.72,0,0,0,0,.59,5.62,5.62,0,0,0,0,.58c.24,2.9,2.28,5.75,6.13,8a28.17,28.17,0,0,0,10.52,3.28c-5.44-.94-9-7-7.28-13.72C378.36,387.79,386.22,376.55,397.1,378.56Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,398c0-.2,0-.38,0-.58s0-.39,0-.59a20.85,20.85,0,0,0-7.12-15.14c2.28,2.34,7.34,11.16,1.84,17.89-3.62,4.42-20.8,10.73-34.94,2.62a14.62,14.62,0,0,0,4.44,3.78c8.18,4.72,21.47,4.72,29.66,0C406.67,403.77,408.72,400.92,409,398Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.79,381.19c.94,2.14-.86,5-4,6.38s-6.49.79-7.43-1.35.87-5,4-6.38S386.85,379.06,387.79,381.19Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65,389.89a2.75,2.75,0,1,1-3.35-.93A2.49,2.49,0,0,1,375.65,389.89Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,392.74a17.54,17.54,0,0,0-35.06,0,6,6,0,0,0,0,1c.2,2.43,1.91,4.81,5.13,6.67,6.84,4,18,4,24.81,0,3.21-1.86,4.92-4.24,5.12-6.67,0-.17,0-.32,0-.49S334,392.91,334,392.74Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,392.74a17.54,17.54,0,0,0-35.06,0,6,6,0,0,0,0,1c.2,2.43,1.91,4.81,5.13,6.67,6.84,4,18,4,24.81,0,3.21-1.86,4.92-4.24,5.12-6.67,0-.17,0-.32,0-.49S334,392.91,334,392.74Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,377.44h0a17.51,17.51,0,0,0-25.14,15.3,6,6,0,0,0,0,1c.2,2.43,1.91,4.81,5.13,6.67a23.25,23.25,0,0,0,8.8,2.75c-4.55-.79-7.49-5.87-6.1-11.47C308.35,385.16,314.92,375.76,324,377.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,393.72c0-.17,0-.32,0-.49s0-.32,0-.49A17.45,17.45,0,0,0,328,380.07c1.9,2,6.14,9.34,1.53,15-3,3.7-17.4,9-29.23,2.2a12.24,12.24,0,0,0,3.72,3.15c6.84,4,18,4,24.81,0C332,398.53,333.75,396.15,334,393.72Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.24,379.64c.79,1.79-.72,4.18-3.37,5.34s-5.42.65-6.21-1.13.72-4.18,3.37-5.34S315.46,377.85,316.24,379.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.08,386.92a2.3,2.3,0,1,1-2.8-.78A2.07,2.07,0,0,1,306.08,386.92Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.09,396.37a15.4,15.4,0,0,0-30.78,0c0,.15,0,.29,0,.43s0,.28,0,.43c.18,2.13,1.68,4.22,4.51,5.86,6,3.47,15.76,3.47,21.78,0,2.81-1.64,4.31-3.73,4.49-5.86,0-.15,0-.28,0-.43S363.1,396.52,363.09,396.37Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.09,396.37a15.4,15.4,0,0,0-30.78,0c0,.15,0,.29,0,.43s0,.28,0,.43c.18,2.13,1.68,4.22,4.51,5.86,6,3.47,15.76,3.47,21.78,0,2.81-1.64,4.31-3.73,4.49-5.86,0-.15,0-.28,0-.43S363.1,396.52,363.09,396.37Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,382.94h0a15.37,15.37,0,0,0-22.07,13.43c0,.15,0,.29,0,.43s0,.28,0,.43c.18,2.13,1.68,4.22,4.51,5.86a20.4,20.4,0,0,0,7.72,2.41c-4-.69-6.58-5.15-5.35-10.07C340.61,389.72,346.39,381.46,354.38,382.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.09,397.23c0-.15,0-.28,0-.43s0-.28,0-.43a15.32,15.32,0,0,0-5.23-11.12c1.67,1.72,5.39,8.2,1.35,13.14-2.66,3.25-15.28,7.89-25.66,1.93a10.81,10.81,0,0,0,3.27,2.77c6,3.47,15.76,3.47,21.78,0C361.41,401.45,362.91,399.36,363.09,397.23Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.54,384.87c.69,1.57-.63,3.67-3,4.69s-4.77.57-5.46-1,.64-3.67,3-4.69S346.85,383.3,347.54,384.87Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.63,391.26a1.84,1.84,0,0,1-1.17,2.28,1.65,1.65,0,1,1,1.17-2.28Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.65,381.41a7.41,7.41,0,0,0-14.82,0v.41a3.81,3.81,0,0,0,2.17,2.82,11.55,11.55,0,0,0,10.49,0,3.8,3.8,0,0,0,2.16-2.82,1.34,1.34,0,0,0,0-.2A1.48,1.48,0,0,0,467.65,381.41Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.65,381.41a7.41,7.41,0,0,0-14.82,0v.41a3.81,3.81,0,0,0,2.17,2.82,11.55,11.55,0,0,0,10.49,0,3.8,3.8,0,0,0,2.16-2.82,1.34,1.34,0,0,0,0-.2A1.48,1.48,0,0,0,467.65,381.41Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.46,374.94h0a7.41,7.41,0,0,0-10.63,6.47v.41a3.81,3.81,0,0,0,2.17,2.82,9.84,9.84,0,0,0,3.72,1.16c-1.92-.33-3.17-2.47-2.58-4.84C456.83,378.21,459.61,374.23,463.46,374.94Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.65,381.82a1.34,1.34,0,0,0,0-.2,1.48,1.48,0,0,0,0-.21,7.36,7.36,0,0,0-2.52-5.35c.81.82,2.6,3.94.65,6.32-1.28,1.57-7.35,3.8-12.35.93a5,5,0,0,0,1.57,1.33,11.55,11.55,0,0,0,10.49,0A3.8,3.8,0,0,0,467.65,381.82Z",
    style: {
      fill: "#455a64",
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.17,375.87c.33.76-.31,1.77-1.43,2.26s-2.29.28-2.62-.48.3-1.76,1.42-2.25S459.83,375.12,460.17,375.87Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.87,379a1,1,0,0,1-1.74.77,1,1,0,0,1,1.74-.77Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.37,372.29a12.26,12.26,0,0,1,24.52,0c0,.11,0,.22,0,.34s0,.22,0,.34c-.13,1.7-1.33,3.36-3.58,4.67-4.79,2.76-12.56,2.76-17.36,0-2.24-1.31-3.44-3-3.58-4.67,0-.12,0-.22,0-.34S213.36,372.4,213.37,372.29Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.37,372.29a12.26,12.26,0,0,1,24.52,0c0,.11,0,.22,0,.34s0,.22,0,.34c-.13,1.7-1.33,3.36-3.58,4.67-4.79,2.76-12.56,2.76-17.36,0-2.24-1.31-3.44-3-3.58-4.67,0-.12,0-.22,0-.34S213.36,372.4,213.37,372.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.31,361.58h0a12.25,12.25,0,0,1,17.58,10.71c0,.11,0,.22,0,.34s0,.22,0,.34c-.13,1.7-1.33,3.36-3.58,4.67a16.32,16.32,0,0,1-6.16,1.92c3.18-.55,5.24-4.1,4.26-8C231.28,367,226.68,360.41,220.31,361.58Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.37,373c0-.12,0-.22,0-.34s0-.23,0-.34a12.23,12.23,0,0,1,4.17-8.87c-1.33,1.37-4.3,6.54-1.08,10.47,2.12,2.59,12.17,6.29,20.45,1.54a8.67,8.67,0,0,1-2.6,2.21c-4.79,2.76-12.56,2.76-17.36,0C214.71,376.33,213.51,374.67,213.37,373Z",
    style: {
      fill: "#9615DB",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.76,363.12c-.55,1.25.5,2.93,2.35,3.74s3.8.46,4.35-.79-.51-2.93-2.36-3.74S226.31,361.87,225.76,363.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.86,368.21a1.47,1.47,0,0,0,.93,1.82,1.32,1.32,0,1,0-.93-1.82Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.67,377a17.79,17.79,0,0,1,35.57,0c0,.17,0,.32,0,.49s0,.33,0,.5c-.21,2.46-1.94,4.88-5.21,6.77-6.94,4-18.22,4-25.17,0-3.25-1.89-5-4.31-5.19-6.77a4.18,4.18,0,0,1,0-.5A4,4,0,0,1,239.67,377Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.67,377a17.79,17.79,0,0,1,35.57,0c0,.17,0,.32,0,.49s0,.33,0,.5c-.21,2.46-1.94,4.88-5.21,6.77-6.94,4-18.22,4-25.17,0-3.25-1.89-5-4.31-5.19-6.77a4.18,4.18,0,0,1,0-.5A4,4,0,0,1,239.67,377Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.73,361.44h0A17.78,17.78,0,0,1,275.24,377c0,.17,0,.32,0,.49s0,.33,0,.5c-.21,2.46-1.94,4.88-5.21,6.77a23.47,23.47,0,0,1-8.92,2.78c4.61-.79,7.6-5.94,6.18-11.63C265.64,369.28,259,359.74,249.73,361.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.67,378a4.18,4.18,0,0,1,0-.5,4,4,0,0,1,0-.49,17.69,17.69,0,0,1,6-12.86c-1.93,2-6.23,9.48-1.56,15.19,3.07,3.75,17.65,9.11,29.66,2.23a12.37,12.37,0,0,1-3.78,3.2c-6.94,4-18.22,4-25.17,0C241.61,382.84,239.87,380.42,239.67,378Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.63,363.68c-.79,1.81.74,4.23,3.42,5.41s5.51.67,6.3-1.15-.73-4.23-3.42-5.41S258.43,361.86,257.63,363.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.94,371.06a2.34,2.34,0,1,0,2.85-.79A2.11,2.11,0,0,0,267.94,371.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,387.41a16.89,16.89,0,0,1,33.76,0,5.53,5.53,0,0,1,0,.94c-.19,2.34-1.84,4.63-4.94,6.43-6.59,3.81-17.29,3.81-23.89,0-3.09-1.8-4.74-4.09-4.93-6.43a5.53,5.53,0,0,1,0-.94Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,387.41a16.89,16.89,0,0,1,33.76,0,5.53,5.53,0,0,1,0,.94c-.19,2.34-1.84,4.63-4.94,6.43-6.59,3.81-17.29,3.81-23.89,0-3.09-1.8-4.74-4.09-4.93-6.43a5.53,5.53,0,0,1,0-.94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.56,372.67h0a16.86,16.86,0,0,1,24.21,14.74,5.53,5.53,0,0,1,0,.94c-.19,2.34-1.84,4.63-4.94,6.43a22.45,22.45,0,0,1-8.47,2.64c4.38-.76,7.21-5.65,5.87-11.05C248.67,380.11,242.33,371.05,233.56,372.67Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,388.35a5.53,5.53,0,0,1,0-.94,16.75,16.75,0,0,1,5.73-12.2c-1.83,1.88-5.91,9-1.48,14.41,2.92,3.57,16.76,8.65,28.16,2.12a11.9,11.9,0,0,1-3.59,3c-6.59,3.81-17.29,3.81-23.89,0C225.85,393,224.2,390.69,224,388.35Z",
    style: {
      fill: "#9615DB",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.06,374.79c-.75,1.72.7,4,3.25,5.14s5.22.63,6-1.09-.7-4-3.25-5.14S241.82,373.07,241.06,374.79Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,381.8a2.21,2.21,0,1,0,2.7-.75A2,2,0,0,0,250.85,381.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,394.82a21,21,0,0,1,41.91,0c0,.2,0,.38,0,.58s0,.39,0,.59c-.24,2.9-2.29,5.75-6.14,8-8.17,4.73-21.46,4.73-29.65,0-3.84-2.22-5.88-5.07-6.12-8a5.82,5.82,0,0,1,0-.59A5.62,5.62,0,0,1,259.83,394.82Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,394.82a21,21,0,0,1,41.91,0c0,.2,0,.38,0,.58s0,.39,0,.59c-.24,2.9-2.29,5.75-6.14,8-8.17,4.73-21.46,4.73-29.65,0-3.84-2.22-5.88-5.07-6.12-8a5.82,5.82,0,0,1,0-.59A5.62,5.62,0,0,1,259.83,394.82Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.69,376.53h0a20.92,20.92,0,0,1,30.05,18.29c0,.2,0,.38,0,.58s0,.39,0,.59c-.24,2.9-2.29,5.75-6.14,8a27.77,27.77,0,0,1-10.51,3.28c5.43-.93,9-7,7.28-13.71C290.43,385.76,282.57,374.52,271.69,376.53Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,396a5.82,5.82,0,0,1,0-.59,5.62,5.62,0,0,1,0-.58A20.89,20.89,0,0,1,267,379.67c-2.28,2.35-7.35,11.17-1.84,17.9,3.62,4.42,20.8,10.73,34.94,2.62A14.4,14.4,0,0,1,295.6,404c-8.17,4.73-21.46,4.73-29.65,0C262.11,401.74,260.07,398.89,259.83,396Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,379.16c-.94,2.14.86,5,4,6.38s6.49.78,7.43-1.35-.87-5-4-6.38S281.93,377,281,379.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.14,387.86a2.75,2.75,0,1,0,3.35-.93A2.47,2.47,0,0,0,293.14,387.86Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.15,408.69a19.14,19.14,0,0,0-38.26,0c0,.18,0,.35,0,.53s0,.35,0,.53c.22,2.65,2.09,5.25,5.6,7.28,7.47,4.32,19.6,4.32,27.08,0,3.5-2,5.36-4.63,5.58-7.28,0-.18,0-.35,0-.53S372.16,408.87,372.15,408.69Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.15,408.69a19.14,19.14,0,0,0-38.26,0c0,.18,0,.35,0,.53s0,.35,0,.53c.22,2.65,2.09,5.25,5.6,7.28,7.47,4.32,19.6,4.32,27.08,0,3.5-2,5.36-4.63,5.58-7.28,0-.18,0-.35,0-.53S372.16,408.87,372.15,408.69Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.32,392h0a19.11,19.11,0,0,0-27.43,16.7c0,.18,0,.35,0,.53s0,.35,0,.53c.22,2.65,2.09,5.25,5.6,7.28a25.34,25.34,0,0,0,9.6,3c-5-.86-8.17-6.4-6.65-12.52C344.21,400.41,351.39,390.15,361.32,392Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.15,409.75c0-.18,0-.35,0-.53s0-.35,0-.53a19,19,0,0,0-6.5-13.83c2.08,2.14,6.71,10.19,1.68,16.33-3.3,4-19,9.81-31.9,2.4a13.33,13.33,0,0,0,4.06,3.44c7.47,4.32,19.6,4.32,27.08,0C370.07,415,371.93,412.4,372.15,409.75Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.83,394.39c.85,1.95-.79,4.56-3.68,5.83s-5.92.71-6.78-1.24.79-4.56,3.68-5.83S352,392.44,352.83,394.39Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.74,402.33a2.51,2.51,0,1,1-3.06-.85A2.27,2.27,0,0,1,341.74,402.33Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.25,410.77a18.2,18.2,0,0,1,36.39,0c0,.17,0,.33,0,.5s0,.34,0,.51c-.21,2.52-2,5-5.33,6.93-7.1,4.1-18.63,4.1-25.75,0-3.33-1.94-5.1-4.41-5.31-6.93,0-.17,0-.33,0-.51S292.24,410.94,292.25,410.77Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.25,410.77a18.2,18.2,0,0,1,36.39,0c0,.17,0,.33,0,.5s0,.34,0,.51c-.21,2.52-2,5-5.33,6.93-7.1,4.1-18.63,4.1-25.75,0-3.33-1.94-5.1-4.41-5.31-6.93,0-.17,0-.33,0-.51S292.24,410.94,292.25,410.77Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.55,394.88h0a18.19,18.19,0,0,1,26.09,15.89c0,.17,0,.33,0,.5s0,.34,0,.51c-.21,2.52-2,5-5.33,6.93a24.28,24.28,0,0,1-9.13,2.85c4.72-.82,7.78-6.09,6.33-11.91C318.82,402.9,312,393.14,302.55,394.88Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.25,411.78c0-.17,0-.33,0-.51s0-.33,0-.5a18.11,18.11,0,0,1,6.18-13.15c-2,2-6.37,9.69-1.6,15.53,3.15,3.84,18.07,9.32,30.34,2.28a12.56,12.56,0,0,1-3.86,3.28c-7.1,4.1-18.63,4.1-25.75,0C294.23,416.77,292.46,414.3,292.25,411.78Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.63,397.17c-.81,1.85.75,4.34,3.5,5.54s5.63.68,6.44-1.17-.75-4.34-3.49-5.55S311.44,395.31,310.63,397.17Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.17,404.72a2.39,2.39,0,1,0,2.91-.81A2.16,2.16,0,0,0,321.17,404.72Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.46,417.13a7.41,7.41,0,0,0-14.82,0v.41a3.83,3.83,0,0,0,2.17,2.82,11.61,11.61,0,0,0,10.49,0,3.81,3.81,0,0,0,2.16-2.82,1.41,1.41,0,0,0,0-.21A1.34,1.34,0,0,0,339.46,417.13Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.46,417.13a7.41,7.41,0,0,0-14.82,0v.41a3.83,3.83,0,0,0,2.17,2.82,11.61,11.61,0,0,0,10.49,0,3.81,3.81,0,0,0,2.16-2.82,1.41,1.41,0,0,0,0-.21A1.34,1.34,0,0,0,339.46,417.13Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.27,410.66h0a7.41,7.41,0,0,0-10.63,6.47v.41a3.83,3.83,0,0,0,2.17,2.82,9.84,9.84,0,0,0,3.72,1.16c-1.92-.33-3.17-2.48-2.58-4.85C328.64,413.92,331.42,410,335.27,410.66Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.46,417.54a1.41,1.41,0,0,0,0-.21,1.34,1.34,0,0,0,0-.2,7.39,7.39,0,0,0-2.52-5.36c.81.83,2.6,4,.65,6.33-1.28,1.56-7.35,3.8-12.35.93a5.17,5.17,0,0,0,1.57,1.33,11.61,11.61,0,0,0,10.49,0A3.81,3.81,0,0,0,339.46,417.54Z",
    style: {
      fill: "#9615DB",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,411.59c.33.76-.31,1.77-1.43,2.26s-2.29.27-2.62-.48.3-1.77,1.42-2.26S331.64,410.84,332,411.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.68,414.67a1,1,0,1,1-1.18-.33A.87.87,0,0,1,327.68,414.67Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,375.16a7.41,7.41,0,0,1,14.81,0,1.48,1.48,0,0,1,0,.21,1.34,1.34,0,0,1,0,.2,3.76,3.76,0,0,1-2.17,2.82,11.59,11.59,0,0,1-10.48,0,3.77,3.77,0,0,1-2.16-2.82,1.34,1.34,0,0,1,0-.2A1.48,1.48,0,0,1,203,375.16Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,375.16a7.41,7.41,0,0,1,14.81,0,1.48,1.48,0,0,1,0,.21,1.34,1.34,0,0,1,0,.2,3.76,3.76,0,0,1-2.17,2.82,11.59,11.59,0,0,1-10.48,0,3.77,3.77,0,0,1-2.16-2.82,1.34,1.34,0,0,1,0-.2A1.48,1.48,0,0,1,203,375.16Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.19,368.69h0a7.4,7.4,0,0,1,10.62,6.47,1.48,1.48,0,0,1,0,.21,1.34,1.34,0,0,1,0,.2,3.76,3.76,0,0,1-2.17,2.82,9.74,9.74,0,0,1-3.71,1.16c1.92-.33,3.16-2.47,2.57-4.84C213.82,372,211,368,207.19,368.69Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,375.57a1.34,1.34,0,0,1,0-.2,1.48,1.48,0,0,1,0-.21,7.35,7.35,0,0,1,2.51-5.35c-.8.82-2.59,3.94-.65,6.32,1.28,1.57,7.36,3.8,12.36.93a5.08,5.08,0,0,1-1.58,1.33,11.59,11.59,0,0,1-10.48,0A3.77,3.77,0,0,1,203,375.57Z",
    style: {
      fill: "#455a64",
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.48,369.62c-.33.76.31,1.77,1.42,2.26s2.3.28,2.63-.48-.31-1.76-1.42-2.26S210.81,368.87,210.48,369.62Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.77,372.7a1,1,0,1,0,1.19-.33A.88.88,0,0,0,214.77,372.7Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.74,245.33l4.06-49.25,16.37,9.45c7.86,4.54,11.38,16.16,10.08,33.32l-2.07,27.59-4.41-15.29c-2.41-8.32-8.53-11.19-17.36-8.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,245.33l-4.06-49.25-16.37,9.45c-7.86,4.54-11.38,16.16-10.08,33.32l2.07,27.59L283,251.15c2.4-8.32,8.52-11.19,17.35-8.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.57,269.15h0l-3.08-13.57H310.26l-3.08,13.57h0c-.81,4.11,1.51,8.38,7,11.53,9.51,5.49,24.94,5.49,34.45,0C354.06,277.53,356.37,273.26,355.57,269.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.38,
    cy: 257.25,
    rx: 21.32,
    ry: 12.31,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.2,269.15c-.81,4.11,1.51,8.38,7,11.53,9.51,5.49,24.94,5.49,34.45,0,5.45-3.15,7.76-7.42,7-11.53l-.86-3.88c.85,3.72-1.26,7.71-6.34,10.64-9.38,5.42-24.59,5.42-34,0-5.06-2.92-7.18-6.89-6.35-10.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.12,260.62c-.84,3.65,1.2,7.53,6.12,10.37,8.92,5.15,23.37,5.15,32.29,0,4.9-2.83,6.94-6.68,6.14-10.32l-1.16-5.09c.87,3.68-1.15,7.55-6.05,10.38-8.32,4.8-21.83,4.8-30.15,0-4.9-2.83-6.92-6.7-6.05-10.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.17,255.58H344c1,4.59,3.85,16.85,4.22,19.65.45,3.45-7.2,9.27-27.32,8.18,9.06,2.5,20.23,1.6,27.73-2.73a17,17,0,0,0,4.91-4.08Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.38,
    cy: 257.25,
    rx: 21.32,
    ry: 12.31,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.86,157.27c0-52.6-22.22-98.07-38.75-108.6l-.44-.29-.08-.05h0a6.36,6.36,0,0,0-6.39,0h0l-.08.05-.44.29c-16.53,10.53-38.75,56-38.75,108.6,0,50.63,14.19,95.5,15.54,99.66l.11.32h0c1,2.94,3.51,5.75,7.46,8,10.7,6.17,28,6.17,38.73,0,4.09-2.36,6.61-5.29,7.57-8.35C359.67,252.76,373.86,207.89,373.86,157.27Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.2,61.32c-4.1-5.87-8.25-10.21-12.09-12.65l-.44-.29-.08-.05h0a6.36,6.36,0,0,0-6.39,0h0l-.08.05-.44.29c-3.84,2.45-8,6.78-12.1,12.66a106.91,106.91,0,0,0-7.08,11.8c.72,2.72,2.89,5.33,6.52,7.42,9.05,5.23,23.72,5.23,32.77,0,3.62-2.09,5.8-4.7,6.52-7.42A106.16,106.16,0,0,0,347.2,61.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,157.27c0,50.63,14.19,95.5,15.54,99.66l.11.32h0c1,2.94,3.51,5.75,7.46,8a31.1,31.1,0,0,0,6,2.59c-6.92-24.89-15-67.15-15-109.31,0-58.29,14.35-99.6,24.72-109.89C311.13,59.2,288.91,104.67,288.91,157.27Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.86,157.27c0,50.63-14.19,95.5-15.54,99.66l-.11.32h0c-1,2.94-3.51,5.75-7.47,8,8-29.33,17.19-64.56,17.19-106.72,0-58.29-22.45-99.6-32.82-109.89C351.64,59.2,373.86,104.67,373.86,157.27Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.23,231.46l-15.36-28.34-4.07,2.34L352.74,250l6.67,5.39a49.83,49.83,0,0,1,17.36,28.17L381.18,304s1.94-12.95,4.06-28.63C387.14,261.28,387.09,245.07,379.23,231.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.74,250l7.06-44.56,15.37,28.34c7.86,13.62,9.38,29.3,8.08,45L381.18,304l-4.41-20.38a49.83,49.83,0,0,0-17.36-28.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.51,231.46l15.36-28.34,4.07,2.34L310,250l-6.67,5.39A49.83,49.83,0,0,0,286,283.58L281.56,304s-1.94-12.95-4.06-28.63C275.6,261.28,275.65,245.07,283.51,231.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,250l-7.06-44.56L287.57,233.8c-7.86,13.62-9.38,29.3-8.08,45L281.56,304,286,283.58a49.83,49.83,0,0,1,17.36-28.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.38,
    cy: 129.24,
    r: 18.61,
    transform: "translate(175.26 448.83) rotate(-85.27)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.38,
    cy: 129.24,
    r: 14.79,
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.38,
    cy: 129.24,
    r: 14.79,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.65,173.83a13.27,13.27,0,1,1-13.27-13.27A13.27,13.27,0,0,1,344.65,173.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.38,
    cy: 173.83,
    r: 9.65,
    transform: "translate(86.07 456.41) rotate(-76.72)",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.38,
    cy: 173.83,
    r: 9.65,
    transform: "translate(86.07 456.41) rotate(-76.72)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.42,109.28a.61.61,0,0,1-.64.54l-.59,0a3.1,3.1,0,0,0-3.2,2.52l-.12.58a.61.61,0,0,1-1.21-.14l0-.6h0a3.1,3.1,0,0,0-2.52-3.2l-.58-.12a.6.6,0,0,1-.49-.67h0a.6.6,0,0,1,.63-.54l.6,0a3.1,3.1,0,0,0,3.2-2.52l.11-.58a.62.62,0,0,1,.68-.49.6.6,0,0,1,.54.63l0,.6a3.11,3.11,0,0,0,2.51,3.2l.59.12a.61.61,0,0,1,.49.67Zm-4.85,1a4.28,4.28,0,0,1,1.76-1.39,4.25,4.25,0,0,1-1.39-1.77,4.2,4.2,0,0,1-1.77,1.4A4.23,4.23,0,0,1,268.57,110.3Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.59,76.18a3.94,3.94,0,1,1-3.45-4.37A3.94,3.94,0,0,1,258.59,76.18ZM252,75.4A2.71,2.71,0,1,0,255,73,2.72,2.72,0,0,0,252,75.4Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.24,62.07a.62.62,0,0,1-.68.54l-2-.24a.61.61,0,1,1,.15-1.22l2,.24A.61.61,0,0,1,288.24,62.07Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.31,63.43l-.24,2a.61.61,0,0,1-1.22-.14l.24-2a.61.61,0,1,1,1.22.14Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.83,62.62a.61.61,0,0,1-.68.54l-2-.25a.61.61,0,0,1-.54-.68.62.62,0,0,1,.69-.54l2,.25A.61.61,0,0,1,292.83,62.62Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.86,58.84l-.24,2a.61.61,0,1,1-1.22-.15l.24-2a.61.61,0,1,1,1.22.14Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.56,108.77h0a.61.61,0,0,1,.34.77l-.19.56h0a3.1,3.1,0,0,0,1.5,3.79l.53.28a.62.62,0,0,1,.28.78.61.61,0,0,1-.77.34l-.56-.19a3.11,3.11,0,0,0-3.79,1.5l-.28.53a.63.63,0,0,1-.78.28.62.62,0,0,1-.34-.77l.19-.56a3.1,3.1,0,0,0-1.5-3.79l-.53-.28a.61.61,0,0,1,.49-1.12l.56.19a3.1,3.1,0,0,0,3.79-1.5l.28-.53A.6.6,0,0,1,394.56,108.77Zm-.38,5a4.3,4.3,0,0,1-.83-2.09,4.3,4.3,0,0,1-2.09.83,4.3,4.3,0,0,1,.83,2.09A4.3,4.3,0,0,1,394.18,113.72Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.61,70.82a3.86,3.86,0,0,1,1.88,1.52A3.94,3.94,0,1,1,377,71.19,3.89,3.89,0,0,1,380.61,70.82ZM378.2,77a3,3,0,0,0,.43.12A2.71,2.71,0,0,0,381.46,73a2.71,2.71,0,1,0-4.55,3A2.81,2.81,0,0,0,378.2,77Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.55,82.13h0l1.9.77a.64.64,0,0,1,.34.81A.62.62,0,0,1,414,84l-1.89-.77a.61.61,0,0,1,.45-1.14Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.65,78.63h0a.61.61,0,0,1,.34.8l-.77,1.9a.64.64,0,0,1-.81.34.61.61,0,0,1-.33-.8l.77-1.9A.62.62,0,0,1,412.65,78.63Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.27,80.38h0l1.9.78a.63.63,0,0,1,.34.8.65.65,0,0,1-.81.34l-1.89-.78a.61.61,0,0,1,.45-1.14Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.91,82.91h0a.62.62,0,0,1,.33.81l-.77,1.89a.6.6,0,0,1-.8.34.61.61,0,0,1-.34-.8l.78-1.9A.61.61,0,0,1,410.91,82.91Z",
    style: {
      fill: "#9615DB"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.7,420.61c.26,1,.81,3.94,6.21,3.94s8.51-2.22,9.58-5,.45-4.78.35-7.18,1.69-3.92,2.08-5.22c.58-1.9-1-4.53-1-4.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.28,407.83a3.25,3.25,0,0,0,.47,2.58,11.23,11.23,0,0,0,8.69,1.88,20.61,20.61,0,0,0,8.91-4,11.89,11.89,0,0,1,6.91-2.35c2.57-.21,4.42-.88,4.59-1.56.28-1.2.25-2-.32-1.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.11,398.71c0,4.93-9.44,5.83-9.21,1.86l-3.29-11.52,10.67-1.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.75,418.15a31.53,31.53,0,0,1,2-3.25,26.5,26.5,0,0,0,3.59-14.84c0-.29-.06-.85.2-1.06s.58,0,.9.09l0,0v0a6.07,6.07,0,0,0,1.71.21,30.93,30.93,0,0,0,4.4-.79c.37,0,.64,1.12.78,2.34.61-.51.71-1.38,1.25-2,.29-.31.43-.34.36-.77s-.09-.54-.14-.82c.47-.21,1.13,1.58,1.72,2.94.68,1.57,1.51,3.34,1.09,5.09a14.17,14.17,0,0,1-1.14,2.77,10.77,10.77,0,0,0-1.28,5c0,.76.19,1.5.18,2.26a6.62,6.62,0,0,1-3.89,6c-3.09,1.45-8,2-11.14.09C166.29,420.8,166.4,419.08,166.75,418.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.06,394.71a7.74,7.74,0,0,1-8.61.57l-1.58-16.81h11.54Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,281.57c2.13,19.56,5,62,5,62a47.85,47.85,0,0,1,4.46,15.32c1.54,11.65,3.35,35.6,3.35,35.6S176.31,398,171,396.31c0,0-12.12-36.78-14.54-48.25-2.11-10-5.85-34.15-5.85-34.15l-4.68,31.56a43.64,43.64,0,0,1,1.51,13.64c-.22,5.39-2.34,27.78-2.34,27.78-1.76,1.66-8.5,1.88-10.75.45,0,0-3.24-36.1-3.72-41.76-.62-7.44-1.77-64.45-1.77-64.45Z",
    style: {
      fill: "#263238"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.62,313.91l-2.61-12a28.39,28.39,0,0,1-10-4.68s1.53,3.84,7.92,6.78l2.66,11.27-2.29,28.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.28,404.29a55,55,0,0,0,10.93-6.45,19,19,0,0,0,1.71-1.56c1-1.22,1.51-3.73,2-4,.15-.1.38,0,.72.16a.73.73,0,0,1,.54-.3l.07.62a7.17,7.17,0,0,0,3.1.84c2.73.12,2.79-.43,3,.44a5.73,5.73,0,0,1,.07,1c1.42-.31,2.77-.74,2.81-1.28l.16-1.93c1.42-.2,1.33,2.45,1.94,5.3.49,2.31,1.12,4,.56,5.71-2.07,2-5.9,1.71-8.06,2.17-3.05.66-4.38,3-8.58,4.68-6.77,2.71-11.25.17-12.6-1C116.65,407.16,117,405.39,119.28,404.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.05,233.65c-6.7,6.31-14,14.51-14,14.51a139.69,139.69,0,0,1-15-7.83,9,9,0,0,1-2.76-2.47,14.13,14.13,0,0,1-1-3.49,26.51,26.51,0,0,0-1.83-5.5,8.52,8.52,0,0,0-5.59-4,14.16,14.16,0,0,1-2.75-.67,4.88,4.88,0,0,1-1.56-1.18,2.62,2.62,0,0,0-.91-.75c-.59-.23-.88.18-1,.68a3.73,3.73,0,0,0,.18,2.21,25.9,25.9,0,0,0,1.79,3.16A11.83,11.83,0,0,1,79.28,234c0,.38-.17,1.17-.64.65a17,17,0,0,0-1.93-2,3.31,3.31,0,0,0-2.56-.75,1.11,1.11,0,0,0-.71.38c-.23.32-.08.54.1.78a7.88,7.88,0,0,1,.52.84c.33.59.67,1.17,1,1.75,2,3.4,4.36,6.8,7.87,8.8.51.29,1,.56,1.55.83,2.23,1.14,6.21,4.37,9.36,6.67a108.15,108.15,0,0,0,9.31,5.7c4.51,2.51,6.5,2.5,7.55,2.19a19.8,19.8,0,0,0,4.17-2.37c4.55-2.9,21.43-17.47,21.43-17.47l3.6-16.06C133.8,223.58,131.22,225,122.05,233.65Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,223.77c-4-.51-7.93,0-13.13,4.56-6.65,5.86-18.88,19.26-18.88,19.26s-5.78-2.67-12-5.93c-.8.05-2.73,1.61-3.61,3.56a9.59,9.59,0,0,0-.9,5.42s8.77,6,14.27,8.75c4.75,2.41,6.39.84,10-1.37s20.26-14.28,20.26-14.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,247.59a12.17,12.17,0,0,0-3.15,5.51s-.61-3.77,1.72-6.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.38,224.44c5.46.83,11.71,1.26,15.55,1.79,4.18.57,4.26,3.22,3.91,10.38-.5,10.24-3.18,22-3.63,30.67l1.47,18c-4.9,5.24-28.39,7.54-40.91-.15,0,0-.34-37.53,0-43.56.59-10.6,6.72-17.38,10.63-17.68C139.4,223.86,143,223,152.38,224.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.07,236.46c.09,2.46,1.19,31.69,1.59,34.51s-3.18,7.19-4.16,7.12-4.51-3.45-4.94-6.58c.24-3.87,3.29-31.19,5.07-35.35Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5,236.5c.05-.12.09-.23.13-.34l2.44.3c0,.2,0,.52,0,.92h0A4.63,4.63,0,0,1,142.5,236.5Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.31,231.14a9.49,9.49,0,0,1-3.65-.32,13.65,13.65,0,0,0-.95,2.68,7.4,7.4,0,0,0,.92,2.66,3,3,0,0,0,2.44.3,9.39,9.39,0,0,0,2.12-2A17.62,17.62,0,0,0,146.31,231.14Z",
    style: {
      fill: "#9615DB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.77,191.45s-3,.42-4.09,2.67c-1,2-.61,6.71.66,11.87a47.39,47.39,0,0,0,3.22,9.71,4,4,0,0,0,2.29,1.84l-.15-6.13-.22-4.28s2.74-3.74,3-6.81c.39-3.95-.44-5.57-.44-5.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07,192.2l-4.23-1.93A2.47,2.47,0,0,1,139,189,2.38,2.38,0,0,1,140.07,192.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.81,197.11a10.08,10.08,0,1,0,10-10.1A10.07,10.07,0,0,0,148.81,197.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.64,206.45c-1,.89-1.87-1.42-2.74-2.32s-3.69-2.13-5.09.84,1.3,7.14,3.41,8.12a3.29,3.29,0,0,0,4.48-1.68L143,222c-2.09,4.73.46,6.48,1.48,9.16.6-2.38,7.11-.91,11-6.34v-4.18a23.89,23.89,0,0,0,5.12.23c2.82-.44,4.29-2.57,5.13-5.61,1.36-4.9,1.9-13.13,0-22.64-3.15-2.44-14.08-2-20.69,2.15C145.56,203.19,143.67,205.56,142.64,206.45Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.34,185.86a.55.55,0,0,0-.41-.32.69.69,0,0,0-.38.17A18.17,18.17,0,0,1,164,187.4a8.94,8.94,0,0,0,0-3.42c-.12-.69-.32-2.3-1.18-2.47-.51-.1-1,.32-1.33.68-3.44,3.22-7.93,1.73-12.08,1.86-3.47.11-7.65,1.52-9.21,4.89-.72,1.54-.84,3.17.57,4.24a9.7,9.7,0,0,0,4.23,1.57c6.9,1.2,16.8,4,21.9-2.39a5,5,0,0,0,1.07-3.38,6.93,6.93,0,0,0-.69-3.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5,220.62s-6.32-1.26-8.52-2.42a7.23,7.23,0,0,1-3-3,9.88,9.88,0,0,0,1.74,3.54c1.61,2,9.8,3.53,9.8,3.53Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,204.55a1.26,1.26,0,1,1-1.27-1.31A1.29,1.29,0,0,1,154,204.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,199.85l-2.8,1.26a1.62,1.62,0,0,1,.8-2.09A1.5,1.5,0,0,1,153.5,199.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,212.48l4,1.49a2.09,2.09,0,0,1-2.72,1.34A2.25,2.25,0,0,1,154.45,212.48Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.75,215.31a2,2,0,0,0,1.11.09,2,2,0,0,0-1.94-1.87,2,2,0,0,0-.55.09A2.17,2.17,0,0,0,155.75,215.31Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.47,200.65l-2.91-1.07a1.49,1.49,0,0,1,1.94-1A1.62,1.62,0,0,1,165.47,200.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.38,204.13a1.26,1.26,0,1,1-1.26-1.31A1.27,1.27,0,0,1,164.38,204.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.1 202.98 158.57 211 162.51 209.64 158.1 202.98",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5,220.93c.8.06,1.15.18,1.8,1.47.74,1.48,1.38,2.83,1.38,2.83A8.91,8.91,0,0,1,156,231c-2.67,2.71-8.59,4.54-8.59,4.54s-.49-2.73-.87-3.86c-.83-2.46-2.07-.51-2.07-.51a2.87,2.87,0,0,1,.67-1.45c.53-.47,3.92-.77,6.62-2.47a9.87,9.87,0,0,0,3.72-4.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.45,231.14a2.79,2.79,0,0,0-.72-2.17,5.3,5.3,0,0,1-.76-3.29c0-1.14,0-3.7,0-3.7a2.25,2.25,0,0,0-2.17,1.7,14.18,14.18,0,0,0-1.15,7.2c.48,2.85,1.7,3.79,1.7,3.79s.71-2.4,1.15-3.52S143.79,229.75,144.45,231.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.35,229.38a2.45,2.45,0,0,0-.2-.51c-.55-1-1.71-.82-2.61-.42a24.3,24.3,0,0,0-2.51,1.67,29.87,29.87,0,0,1-6.06,3.45,2.79,2.79,0,0,1-2.14.27,5,5,0,0,1,.64-1.81,8.73,8.73,0,0,0,.8-1.76,2.45,2.45,0,0,0-.16-1.88.81.81,0,0,0-.88-.46,1.37,1.37,0,0,0-.39.29c-.65.67-1.28,1.34-1.94,2a12.68,12.68,0,0,0-1.5,2,32.57,32.57,0,0,0-1.71,3,22.08,22.08,0,0,1-4.06,5.59c-2,1.91-12.17,10.44-14.08,12.11,0,0-11.27-12.54-14.77-16.75-6.53-7.83-9.13-9.54-13.26-10l1.44,21.1s17.62,15.32,21.38,18c4.67,3.52,6.52,3,8.5,1s5.25-5.25,7-7.29c2.6-3.07,5.18-6.15,7.85-9.16.67-.75,1.35-1.5,2-2.22a12.16,12.16,0,0,1,3.22-2.74c1.77-1,4-1.15,5.82-2a19,19,0,0,0,5.12-3.48,9.26,9.26,0,0,0,2.48-3.53,12.31,12.31,0,0,0,.15-5.54A7.08,7.08,0,0,0,232.35,229.38Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16,226c3.47.41,6.15.44,10.39,4.81,4.6,4.75,18.94,21.41,18.94,21.41l11.14-8.83a7.6,7.6,0,0,0,2,4.35,8.9,8.9,0,0,0,4.42,2.73s-10.64,13.07-14.16,16c-3.23,2.66-4.44,2.33-8-.1-4.08-2.79-22-18-22-18S159.81,237.17,166.16,226Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.49,252.23a19,19,0,0,0-5.11,7.19,11,11,0,0,1,3.89-8.59Z",
    style: {
      fill: "#37474f"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovate);
export default __webpack_public_path__ + "static/media/innovate.cf2d68c188763d474948ee1954ccba07.svg";
export { ForwardRef as ReactComponent };